import moment from 'moment'
import { Link } from 'react-router-dom'
import maleSVG from '../../assets/images/male.svg'

export const IdeasReview = ({ ideaId, status, empName, category, department, createdDate, hearts, likes, dislikes }) => {

    const statusClass = status == 'In Review'
        ? 'badge-light-primary'
        : status == "New"
            ? "badge-light-warning"
            : status == "Approved"
                ? 'badge-light-success'
                : 'badge-light-danger'
    return (
        <>
            <tr>
                <td width={"100px"}>
                    <span className={`badge badge-pill w-75p py-5 ${statusClass}`}>
                        {status}
                    </span>
                </td>
                <td width={"200px"}>
                    <div className="d-flex justify-content-start align-items-center">
                        <div className="starshot-ring mr-1">
                            <div className="avatar">
                                <div className="text-icon font-lato">{empName[0]}</div>
                            </div>
                        </div>

                        <div className="profile-user-info">
                            <strong>{empName}</strong>
                            <br />
                            <small>Employee name</small>
                        </div>
                    </div>
                </td>
                <td width={"150px"}>
                    <strong>{category}</strong>
                    <br />
                    <small>Category</small>
                </td>
                <td width={"150px"}>
                    <strong>{department}</strong>
                    <br />
                    <small>Department</small>
                </td>
                <td>
                    <i className="fas fa-heart mr-5 text-danger" />{hearts}
                </td>
                <td>
                    <i className="fas fa-thumbs-up mr-5 text-primary" />{likes}
                </td>
                <td>
                    <i className="fas fa-thumbs-down mr-5 text-primary" />{dislikes}
                </td>
                <td className="text-right">
                    <strong>{moment(createdDate).format("MMM Do YY")}</strong>
                    <br />
                    <small>Date</small>
                </td>
                <td className="text-right">
                    <strong>{moment(createdDate).format("h:mm a")}</strong>
                    <br />
                    <small>Time</small>
                </td>
                <td style={{ textAlign: 'center' }}>
                    <Link to={`/ideas/idea-details/${ideaId}`}
                        href="admin-ideas-details.html"
                        className="btn btn-primary btn-sm text-white rounded-10 font-11 waves-effect waves-float waves-light">
                        Details
                    </Link>
                </td>
            </tr>


        </>
    )
}